import axios from "axios";
import React, { useEffect, useState } from "react";
import "./ListBU.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { BUReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

const ListBU = () => {
  // dispatch function
  const dispatch = useDispatch();

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  // const Download_Permission = useSelector(
  //   (state) => state.AccessTocken.Download_Permission
  // );

  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  //BU edit related selectors
  const BU_id = useSelector((state) => state.BU.BU_id);
  const BU_name = useSelector((state) => state.BU.BU_name);
  // const BUstatus = useSelector((state) => state.BU.BU_status);

  //Add BU and Edit BU related selectors
  const BU_edit = useSelector((state) => state.BU.BU_edit);
  const BU_IsPane = useSelector((state) => state.BU.BUIsPane);
  const addBU_IsPane = useSelector((state) => state.BU.addBUIsPane);

  //state hook for ListBU  API's
  const [ListBU, setListBU] = useState([]);
  const [buCount, setBuCount] = useState(null);

  //state hook for Add App API's
  const [newBU, setNewBU] = useState(null);
  const [newStatus, setNewStatus] = useState(null);

  //state hook for Edit App  API's
  const [BUId, setBUId] = useState(null);
  const [BUName, setBUName] = useState(null);
  const [Editstatus, setEditStatus] = useState("");
  const [statusName, setStatusName] = useState("");

  // filtering
  const [BUfilter, setBUfilter] = useState("");
  const [BUselData, setBUselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyBUfilter, setDummyBUfilter] = useState("");
  const [dummyBUselData, setDummyBUselData] = useState("");

  const BU_filter = useSelector((state) => state.BU.BU_filter);

  // dependency
  const [IsDependent, setIsDependent] = useState(false);

  const [tableHeight, setTableHeight] = useState(false);

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // height: 300,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  //Header for API's
  const options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, BUselData, BUfilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, BUselData, BUfilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, BUselData, BUfilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, BUselData, BUfilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      dispatch(sidebarReducer.apiLoad(true));
      setListBU([]);
      setPageSelected(pageNo);

      await axios
        .get(`businessunit/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            setListBU(response.data.data.rows);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);
      dispatch(sidebarReducer.apiLoad(true));

      if (!isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        if (TargetColomn === "te_bustatus") {
          let status = BUfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        }

        await axios
          .get(
            `businessunit/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            // `businessunit/list?limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              setListBU(response.data.data.rows);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        if (dummyBUselData === "te_bustatus") {
          let status = dummyBUfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        } else if (dummyBUselData !== "te_bustatus") {
          keyWord = dummyBUfilter;
        }

        await axios
          .get(
            `businessunit/list/?page=${pageNo}&limit=${listLimit}&${dummyBUselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              setListBU(response.data.data.rows);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };

  //Update Listingtable
  const responseData = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(
        `businessunit/list/?page=${pageSelected}&limit=${listLimit}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
          setBuCount(response.data.data.count);
          return setListBU(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Add BU API
  const newAddBU_data = {
    BUName: newBU,
    BUStatus: newStatus,
  };

  const onAddBU = async (e) => {
    e.preventDefault();
    // dispatch(sidebarReducer.apiLoad(true));

    await axios
      .post("businessunit/create", newAddBU_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Business unit '${newAddBU_data.BUName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }

          dispatch(BUReducer.addBU_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Update BU API
  const newBU_data = {
    BUId: BUId,
    BUName: BUName,
    BUStatus: Editstatus,
  };

  // for updating the BU
  const onUpdate = async (BUId) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`businessunit/update/${BUId}`, newBU_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Business unit '${newBU_data.BUName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.update_success(true));
          }

          dispatch(BUReducer.BU_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListBU"));
          dispatch(BUReducer.BU_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const onDelete = async (id) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .delete(`businessunit/delete/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(BUReducer.BU_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListBU"));
          dispatch(sidebarReducer.delete_success(true));
          dispatch(BUReducer.BU_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.delete_success(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Select an BU from the table to get the pop up
  async function onEdit(item) {
    await axios
      .get(`businessunit/details/${item.te_buid}`, options)
      .then((response) => {
        if (response.status === 200) {
          setIsDependent(response.data.data.dependency);

          setBUId(response.data.data.te_buid);
          setBUName(response.data.data.te_buname);
          setEditStatus(response.data.data.te_bustatus);

          if (response.data.data.te_bustatus === "1") {
            setStatusName("Active");
            setStatusName(statusName); //V I
          }
          if (response.data.data.te_bustatus === "0") {
            setStatusName("Inactive");
          }

          dispatch(BUReducer.BU_id(response.data.data.te_buid));
          dispatch(BUReducer.BU_name(response.data.data.te_buname));
          dispatch(BUReducer.BU_status(response.data.data.te_bustatus));
          dispatch(BUReducer.BU_IsPane(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  //Cancel button function
  const onCancel = async () => {
    dispatch(sidebarReducer.apiLoad(false));
    await axios
      .get(`businessunit/details/${BUId}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setBUName(BU_name);
          setEditStatus(response.data.data.te_bustatus);
          dispatch(BUReducer.BU_edit(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line
  }, []);

  const handleSearch = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));

    if (TargetColomn === "te_bustatus") {
      let status = BUfilter.toLowerCase();
      if (status === "active") {
        keyWord = "1";
      } else if (status === "inactive") {
        keyWord = "0";
      }
    }

    await axios
      .get(
        // `businessunit/list?page=${pageSelected}&${TargetColomn}=${keyWord}`,
        `businessunit/list?limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setListBU(response.data.data.rows);
          setBuCount(response.data.data.count);

          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const handleReset = () => {
    // e.preventDefault();

    dispatch(BUReducer.BU_filter(true));
    setBUfilter("");
    setBUselData("");
    setDummyBUfilter("");
    setDummyBUselData("");
    setIsFilterIReset(false);
    responseData();
  };

  const handleReset1 = () => {
    setBUfilter("");
    setBUselData("");
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "84.6vh" }}>
              {/** ROW 1 for header */}
              <div className="row g-0 p-0 border-bottom">
                <div className="col">
                  <div
                    className=" g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>Business Unit</strong>
                            </h5>
                          </div>
                        </div>
                      </div>

                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            <button
                              className="btn"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "180px",
                              }}
                              // ref={addRef}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(BUReducer.addBU_IsPane(true));
                                  handleReset();
                                }
                              }}
                            >
                              <span
                                className="ToolTipB"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Business Unit
                                <span
                                  className="ToolTipTextB"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add a Business Unit."
                                    : "You cannot add a Business Unit."}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="p-2">
                            {BU_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(
                                  //   e,
                                  //   BUselData,
                                  //   BUfilter.toLowerCase());
                                  setTableHeight(true);
                                  dispatch(BUReducer.BU_filter(false));
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "78px",
                                }}
                                onClick={() => {
                                  handleReset();
                                  setTableHeight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0">
                <div className="col">
                  <div className="container-fluid g-0 ">
                    {!BU_IsPane && !addBU_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify-content-start">
                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    // sx={{
                                    //   "& > :not(style)": {
                                    //     zIndex: "0",
                                    //   },
                                    // }}
                                    value={BUfilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setBUfilter(val);
                                      setDummyBUfilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={BUselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setBUselData(val);
                                        setDummyBUselData(val);
                                      }}
                                    >
                                      <MenuItem value="te_buname" size="small">
                                        Business Unit
                                      </MenuItem>
                                      <MenuItem
                                        value="te_bustatus"
                                        size="small"
                                      >
                                        {" "}
                                        Status
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(e, BUselData, BUfilter);
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      BUfilter.length > 0 &&
                                      BUselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      BUfilter.length > 0 &&
                                      BUselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ROW 2 table */}
                    {tableHeight ? (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "60vh" }}
                      >
                        {!apiLoad ? (
                          <table className="table table-hover ListUserTable border">
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Status</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "left" }}>
                              {ListBU.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className=" border text-center mb-0"
                                  >
                                    {" "}
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                ListBU.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      handleReset();
                                    }}
                                    style={{
                                      backgroundColor: `${
                                        item.te_buid === BU_id &&
                                        BU_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td
                                      className="border text-start"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.te_bustatus === "0"
                                        ? "Inactive"
                                        : "Active"}{" "}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "90vh" }}
                      >
                        {!apiLoad ? (
                          <table className="table table-hover ListUserTable border">
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Status</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "left" }}>
                              {ListBU.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className=" border text-center mb-0"
                                  >
                                    {" "}
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                ListBU.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      handleReset();
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: `${
                                        item.te_buid === BU_id &&
                                        BU_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td
                                      className="border text-start"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.te_bustatus === "0"
                                        ? "Inactive"
                                        : "Active"}{" "}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* pagination footer */}
            {!apiLoad && (
              <div className="container">
                <div className="row main-footer">
                  <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                    Total Records: {buCount}
                  </div>
                  <div className="col-4 mt-2">
                    <div className="d-flex justify-content-center ">
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            leftEndArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== 1 && leftArrow();
                          }}
                        ></i>
                      </div>
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index1_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(index1_pagenation, BUselData, BUfilter);
                        }}
                      >
                        {index1_pagenation}
                      </div>
                      {noOfPages > 1 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index2_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index2_pagenation,
                              BUselData,
                              BUfilter
                            );
                          }}
                        >
                          {index2_pagenation}
                        </div>
                      )}
                      {noOfPages > 2 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index3_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index3_pagenation,
                              BUselData,
                              BUfilter
                            );
                          }}
                        >
                          {index3_pagenation}
                        </div>
                      )}
                      {noOfPages > 3 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index4_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index4_pagenation,
                              BUselData,
                              BUfilter
                            );
                          }}
                        >
                          {index4_pagenation}
                        </div>
                      )}
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== noOfPages && rightArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            rightEndArrow();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-2 ">
                    <div className="d-flex justify-content-end me-3">
                      <span>
                        <strong>Page {pageSelected} </strong> of{" "}
                        <strong>{noOfPages}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/** SlidingPan pop up for selecting and editing user data */}
          {
            <SlidingPane
              className="some-custom-class"
              overlayClassName="some-custom-overlay-class"
              width="71%"
              hideHeader
              isOpen={BU_IsPane}
              onRequestClose={() => {
                onCancel();
              }}
            >
              <div
                className="container-fluid  "
                style={{
                  backgroundColor: "#f2f3f5",
                  height: "54px",
                }}
              >
                <div className="row">
                  <div className="col-3">
                    <div className="d-flex align-items-center ">
                      <div
                        className="px-1 pt-1"
                        onClick={() => {
                          dispatch(BUReducer.BU_edit(false));
                          dispatch(sidebarReducer.stringUpdate("ListBU"));
                          dispatch(BUReducer.BU_IsPane(false));
                        }}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </div>
                      <div
                        className="border-start"
                        // className="px-2 pt-3 pb-1 border-secondary border-opacity-25 border-start"
                        style={{ height: "54px" }}
                      >
                        <h5 className="px-1 pt-3">
                          <strong>{BU_name}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-9" style={{ height: "54px" }}>
                    <div
                      className="d-flex flex-row-reverse bd-highlight"
                      style={{ height: "54px" }}
                    >
                      <div
                        className="p-0 border-start"
                        // style={{ backgroundColor: "red" }}
                      >
                        {BU_edit ? (
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                            }}
                            onClick={() => onUpdate(BUId)}
                          >
                            <i className="bi bi-file-earmark-diff-fill"></i>
                            &nbsp;Save Changes
                          </button>
                        ) : (
                          <div>
                            <button
                              className="button"
                              style={{
                                zIndex: "1100",
                                // paddingTop: "3px",
                                border: "none",
                                height: "54px",
                              }}
                              onClick={() =>
                                Edit_Permission === 1 &&
                                dispatch(BUReducer.BU_edit(!BU_edit))
                              }
                            >
                              <span
                                className="ToolTipBEdit"
                                // style={{
                                //   backgroundColor: "var(--themes-color)",
                                // }}
                              >
                                <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                                Record
                                <span
                                  className="ToolTipTextBEdit"
                                  style={{
                                    backgroundColor:
                                      Edit_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Edit_Permission === 1
                                    ? "You can edit the Business Unit."
                                    : "You cannot edit the Business Unit."}
                                </span>
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                      {BU_edit && (
                        <div
                          className=" border-start "
                          style={{ height: "54px" }}
                          onClick={() => {
                            setPopUp(false);

                            onCancel();
                          }}
                        >
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                              minWidth: "85px",
                            }}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                            &nbsp;Cancel Changes
                          </button>
                        </div>
                      )}
                      <div className="p-0 border-start">
                        <button
                          className="button"
                          // data-bs-toggle="modal"
                          data-bs-target="#DeleteUser"
                          // data-backdrop="false"
                          style={{
                            zIndex: "1100",
                            border: "none",
                            height: "54px",
                            minWidth: "85px",
                          }}
                          onClick={() => {
                            Delete_Permission === 1 && setPopUp(true);
                          }}
                        >
                          <span className="ToolTipBDelete">
                            <i className="bi bi-trash-fill"></i>&nbsp; Delete
                            record
                            <span
                              className="ToolTipTextBDelete"
                              style={{
                                backgroundColor:
                                  Delete_Permission === 1
                                    ? "var(--themes-color)"
                                    : "red",
                              }}
                            >
                              {Delete_Permission === 1
                                ? "You can delete the Business Unit."
                                : "You cannot delete the Business Unit."}
                            </span>
                          </span>
                        </button>
                      </div>
                      <div className="mode" style={{ padding: "14px" }}>
                        <div className="d-flex justify-content-center">
                          <i>
                            <strong style={{ color: "blue" }}>
                              {BU_edit ? "Edit Mode" : "View Mode"}
                            </strong>
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row contentscroll" style={{ width: "101.1%" }}>
                <div className="col ms-3 mt-2">
                  {/* <h5>Basic information:</h5> */}
                  <form style={{ width: "99%" }}>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        size="small"
                        className="form-control mt-3"
                        id="formGroupExampleInput"
                        label="Name"
                        value={BUName}
                        onChange={(e) => setBUName(e.target.value)}
                        disabled={BU_edit ? false : true}
                      />
                    </div>

                    <div
                      onMouseDown={() => {
                        if (BU_edit) setStatusName("Status");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {/* {statusName} */}
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disabled={BU_edit ? false : true}
                          size="small"
                          label="inactiv"
                          value={Editstatus}
                          variant="outlined"
                          onChange={(e) => {
                            let val = e.target.value;
                            setEditStatus(val);
                          }}
                        >
                          <MenuItem value="1">Active</MenuItem>
                          <MenuItem value="0">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <br />
                  </form>
                </div>
              </div>
            </SlidingPane>
          }

          {/** SlidingPan pop up for adding new BU data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="71%"
            hideHeader
            isOpen={addBU_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              //  onCancel();
            }}
          >
            <div
              className="container-fluid m-0 g-0 border"
              style={{ backgroundColor: "#f2f3f5", minHeight: "5px" }}
            >
              <div className="col-3">
                <div className="d-flex align-items-center flex-row">
                  <div
                    className="px-2 my-1"
                    onClick={() => {
                      // dispatch(sidebarReducer.stringUpdate("ListBU"));
                      dispatch(BUReducer.addBU_IsPane(false));
                    }}
                  >
                    <i className="bi bi-arrow-right"></i>
                  </div>
                  <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                    <h5 style={{ whiteSpace: "nowrap" }}>
                      <strong>Add Business Unit</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-9"></div>
            </div>

            <div className="row contentscroll" style={{ width: "101.5%" }}>
              <div className="col ms-3 mt-2">
                <form onSubmit={(e) => onAddBU(e)} style={{ width: "99%" }}>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      size="small"
                      id="formGroupExampleInput"
                      label="Name"
                      variant="outlined"
                      required
                      onChange={(e) => setNewBU(e.target.value)}
                    />
                  </div>
                  <div>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        // value={age}
                        label="inactiv"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setNewStatus(val);
                        }}
                      >
                        <MenuItem value={"1"}>Active</MenuItem>
                        <MenuItem value={"0"}>Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-light text-white"
                      type="submit"
                      style={{ backgroundColor: "var(--themes-color)" }}
                    >
                      &nbsp;Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This Business Unit has dependency, Cannot delete this Business Unit"
                      : "Are you sure you want to delete this Business Unit?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(BUId);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
};
export default ListBU;
